module.exports = __webpack_public_path__ + "static/greycellular-aec5fbb54957434ea0c93c5aeff00508.png";